import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import React from "react";

import TagChip from "../TagChip";
import { AutocompleteValue, FormikInMemoryCombobox } from "./InMemoryCombobox";

const startAdornment: React.ReactElement = (
  <InputAdornment position="start">
    <SearchIcon />
  </InputAdornment>
);

function renderTags(
  value: AutocompleteValue[],
  getTagProps: any
): React.ReactElement[] {
  return value.map((option, index) => (
    <TagChip
      label={option.label}
      {...getTagProps({ index })}
      onDelete={
        // remove the delete button, users must unselect from the dropdown
        undefined
      }
      key={`tag-chip-${index}-${option.id}`}
    />
  ));
}

export function FormikTagCombobox({
  name,
  label,
  bottomLabel,
  options,
}: {
  name: string;
  label: string;
  bottomLabel: string;
  options: AutocompleteValue[];
}): React.ReactElement {
  return (
    <FormikInMemoryCombobox
      name={name}
      label={label}
      bottomLabel={bottomLabel}
      options={options}
      renderTags={renderTags}
      startAdornment={startAdornment}
    />
  );
}
